import { ContributorPerson } from "@/context/Auth/CombinedAuthContext";
import {
	ContributorInvoice,
	CreateContributorInvoiceParams,
	RegisterExternalContributorParams,
	SingleContributorInvoice,
} from "@/types/external-contributors.types";
import axios from "axios";
import { Invoice } from "./invoice-functions";
import api from "./refresh";

const server_url = process.env.REACT_APP_SERVER_DOMAIN;

export const externalContributorCreate = async (
	accessToken: string,
	data: RegisterExternalContributorParams
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};

	const res = await axios.post(
		`${server_url}auth/externaluserregister`,
		data,
		config
	);

	return res.data;
};

export const contributorLogin = async (
	email: string,
	password: string
): Promise<ContributorPerson> => {
	const params = { email, password };
	const res = await axios.post(`${server_url}auth/externallogin`, params, {
		headers: {
			"Content-Type": "application/json",
		},
	});

	console.log("Contributor Login Response:", res);

	const contributorData = {
		email: res.data.user.email,
		username: res.data.user.username,
		accessToken: res.data.access,
		refreshToken: res.data.refresh,
		persontype: "contributor" as const,
	};

	return contributorData;
};

export const createContributorInvoice = async (
	accessToken: string,
	data: CreateContributorInvoiceParams[]
): Promise<{ message: string }> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await axios.post(
		`${server_url}contributors/create-contributor-invoice`,
		data,
		config
	);
	return res.data;
};

export const getContributorInvoices = async (
	accessToken: string
): Promise<ContributorInvoice[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await api.get(
		`${server_url}contributors/getallmasterinvoicespercontributor`,
		config
	);
	return res.data;
};

export const getAllContributorInvoicesByDate = async (
	accessToken: string,
	startdate: string,
	enddate: string
): Promise<Invoice[]> => {
	const headers = {
		Authorization: `Bearer ${accessToken}`,
		"Content-Type": "application/json",
	};

	const config = {
		headers: headers,
	};
	const res = await api.get(
		`${server_url}contributors/getallcontributermasterinvoices?startdate=${startdate}&enddate=${enddate}`,
		config
	);
	return res.data;
};

export const exportContributorInvoicesByDate = async (
	accessToken: string,
	startdate: string,
	enddate: string
): Promise<Blob> => {
	const headers = {
		Authorization: `Bearer ${accessToken}`,
	};

	const config = {
		headers: headers,
		responseType: "blob" as const,
	};
	const res = await axios.get(
		`${server_url}contributors/exportcontributorinvoicestoexcel?startdate=${startdate}&enddate=${enddate}`,
		config
	);
	return res.data;
};

export const getSingleContributorInvoice = async (
	accessToken: string,
	invoicemasterid: string
): Promise<SingleContributorInvoice[]> => {
	const headers = {
		Authorization: `Bearer ${accessToken}`,
		"Content-Type": "application/json",
	};

	const config = {
		headers: headers,
	};
	const res = await api.get(
		`${server_url}contributors/get-contributor-invoices?invoicemasterid=${invoicemasterid}`,
		config
	);
	return res.data;
};

export const getSingleMasterContributorInvoice = async (
	accessToken: string,
	invoicemasterid: string
): Promise<ContributorInvoice> => {
	const headers = {
		Authorization: `Bearer ${accessToken}`,
		"Content-Type": "application/json",
	};

	const config = {
		headers: headers,
	};
	const res = await axios.get(
		`${server_url}contributors/getsinglemasterinvoicepercontributor?invoicemasterid=${invoicemasterid}`,
		config
	);
	return res.data[0];
};

export const getManagerContributorInvoices = async (
	accessToken: string
): Promise<Invoice[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await axios.get(
		`${server_url}contributors/get-contributor-invoices-manager-list`,
		config
	);
	return res.data;
};

export const getFinanceContributorInvoices = async (
	accessToken: string
): Promise<Invoice[]> => {
	const config = {
		headers: {
			Authorization: `Bearer ${accessToken}`,
			"Content-Type": "application/json",
		},
	};
	const res = await axios.get(
		`${server_url}contributors/get-contributor-invoices-finance-list`,
		config
	);
	return res.data;
};

export const refreshContributorToken = async (
	refreshToken: string
): Promise<{ accessToken: string; refreshToken: string }> => {
	const config = {
		headers: {
			"Content-Type": "application/json",
		},
	};
	const res = await axios.post(
		`${server_url}auth/tokenrefresh`,
		{
			refresh: refreshToken,
		},
		config
	);
	return res.data;
};
